<div class="container">
    <div *ngIf="isLoading" class="row center">
        <div class="spinner-border text-danger" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div *ngIf="!isLoading" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12">
            <div class="col-md-9 col-xs-9 mgb-10">
                <h2>Match List For Live Tv</h2>
            </div>
            <div class="col-md-12 col-xs-12">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th class="center pd1p">#</th>
                                <th>Event ID</th>
                                <th>Market ID</th>
                                <th>Event Name</th>
                                <th>Owner</th>
                                <th>Open Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of match; let i = index">
                                <td class="center pd1p">{{ i+1 }}</td>
                                <td>{{ data.eventId }}</td>
                                <td>{{ data.marketId }}</td>
                                <td>{{ data.eventName }}</td>
                                <td *ngIf="data.type=='up'">U.P</td>
                                <td *ngIf="data.type!='up'">Others</td>
                                <td>{{ data.openDate }}</td>
                                <td>
                                    <!-- <select #chNo class="form-control w100">
                                        <option value="1">-- Select Ch No. -- </option>
                                        <option value="1" [selected]="data.channelNo == '1'">Ch 1</option>
                                        <option value="2" [selected]="data.channelNo == '2'">Ch 2</option>
                                        <option value="3" [selected]="data.channelNo == '3'">Ch 3</option>
                                        <option value="4" [selected]="data.channelNo == '4'">Ch 4</option>
                                    </select>
                                    <button class="btn btn-primary fbtn" (click)="setCh(data, chNo)"> Set Ch No.
                                    </button> -->

                                    <input id="mEventId{{ i }}" value="{{ data.channelNo }}" type="text"
                                        class="form-control w100">
                                    <button id="mbtn{{ i }}" (click)="setEventId(i, data.eventId)"
                                        class="btn btn-primary fbtn">
                                        Set Url
                                    </button>
                                    <div id="mprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                                        <div class="spinner-border2 text-danger" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                    <span class="error" id="merror{{ i }}">Please Fill Field First</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>